<template>
    <Transition name="modal" :duration="400">
        <div v-if="props.show" class="fixed z-[60] inset-0">
            <!-- Scrim -->
            <div class="scrim absolute inset-0 bg-gray-950/50"></div>
            <div class="dialog absolute inset-0 flex items-center justify-center overflow-y-auto" @click="handleClose">
                <div class="flex items-start justify-center max-h-screen w-full">
                    <div class="py-4 px-2 sm:py-12 sm:px-6 w-full flex items-start justify-center">
                        <!-- Dialog -->
                        <div :class="dialogClasses" @click.stop>
                            <!-- Dialog Header -->
                            <div class="mb-4" v-if="slots['header-title']">
                                <div class="w-full flex justify-between items-center">
                                    <div class="text-2xl font-medium"><slot name="header-title"></slot></div>

                                    <div @click="handleClose" v-if="showCloseButton">
                                        <IconButton icon="close" variant="light" size="md" />
                                    </div>
                                </div>
                                <div v-if="slots['header-subtitle']" class="text-sub mt-4">
                                    <slot name="header-subtitle"></slot>
                                </div>
                            </div>
                            <slot></slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script setup lang="ts">
    import { useSlots, type Slots, computed } from 'vue'
    const slots: Slots = useSlots()
    const emit = defineEmits(['close'])
    import { IconButton } from '@tapp.online/ui'

    const props = withDefaults(
        defineProps<{
            show?: boolean
            width?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'
            showCloseButton?: boolean
        }>(),
        {
            show: false,
            width: 'xl',
            showCloseButton: true
        }
    )

    const dialogClasses = computed(() => {
        const baseClasses = `bg-transparent-light-75 rounded-3xl p-6 shadow-sm backdrop-blur relative w-full`
        const widthVariants = {
            xs: 'max-w-[300px]',
            sm: 'max-w-sm',
            md: 'max-w-md',
            lg: 'max-w-lg',
            xl: 'max-w-xl',
            '2xl': 'max-w-2xl'
        }
        return [baseClasses, widthVariants[props.width]]
    })

    const handleClose = () => {
        emit('close')
    }
</script>

<style>
    .modal-enter-active .scrim,
    .modal-leave-active .scrim {
        transition: all 400ms ease-in-out;
    }

    .modal-enter-from .scrim,
    .modal-leave-to .scrim {
        opacity: 0.1; /* hack to fix blur transition */
    }

    .modal-enter-active .dialog,
    .modal-leave-active .dialog {
        transition: all 200ms ease;
    }

    .modal-enter-from .dialog {
        transform: scale(0.9) translateY(20px);
    }
    .modal-leave-to .dialog {
        transition: all 300ms ease;
        transform: scale(0.95);
        opacity: 0;
    }
</style>
